/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-escape */

import { User } from "api/types";
import Button from "components/Button";
import { Option } from "components/Select";
import { useState } from "react";
import { useQueryClient } from "react-query";
import { getCarePlanAndCareTeamDetailsInformationData, getContactInformationData, getPersonalInformationData, getResidentialAndMailingDetailsInformationData } from "./common";
import { StepNames } from "./clientDetail";
interface Outcomes {
  statutory: React.ReactNode | null;
  "reference/1": React.ReactNode | null;
  "reference/2": React.ReactNode | null;
  "police-check": React.ReactNode | null;
  interview: React.ReactNode | null;
}

export const useClientDetails = (
  user: User,
  isAdminView = false,
  onEditClick?: (stepName: StepNames) => void,
  adminStaffOptions?: Option[],
  admin?: User,
  isSuperAdminView = false
) => {
  const [showInterviewConfirmModal, setShowInterviewConfirmModal] =
    useState(false);
  const [showAdditionalQuestionSection, setShowAdditionalQuestionSection] =
    useState(false);
  const [showAdditionalReferenceSection1, setShowAdditionalReferenceSection1] =
    useState(false);
  const [showAdditionalReferenceSection2, setShowAdditionalReferenceSection2] =
    useState(false);
  const [
    showAdditionalVehicleInspectionSection,
    setShowAdditionalVehicleInspectionSection,
  ] = useState(false);
  const queryClient = useQueryClient();

  return [
    {
      title: "Personal details",
      data: getPersonalInformationData(user),
      footer: isAdminView && (
        <Button
          variant="primary"
          onClick={() =>
            onEditClick && onEditClick(StepNames.PERSONAL_DETAILS)
          }
        >
          Edit
        </Button>
      ),
      footerClassName: "justify-end",
    },
    {
      title: "Contact details",
      data: getContactInformationData(user),
      footer: isAdminView && (
        <Button
          variant="primary"
          onClick={() =>
            onEditClick && onEditClick(StepNames.CONTACT_DETAILS)
          }
        >
          Edit
        </Button>
      ),
      footerClassName: "justify-end",
    },
    {
      title: "Residential and mailing details",
      data: getResidentialAndMailingDetailsInformationData(user),
      footer: isAdminView && (
        <Button
          variant="primary"
          onClick={() =>
            onEditClick && onEditClick(StepNames.RESIDENTIAL_AND_MAILING_DETAILS)
          }
        >
          Edit
        </Button>
      ),
      footerClassName: "justify-end",
    },
    {
      title: "Care plan and care team details",
      data: getCarePlanAndCareTeamDetailsInformationData(user),
      footer: isAdminView && (
        <Button
          variant="primary"
          onClick={() =>
            onEditClick && onEditClick(StepNames.PERSONAL_DETAILS)
          }
        >
          Edit
        </Button>
      ),
      footerClassName: "justify-end",
      bodyContainerClassName: "!bg-gray-200"
    },
  ];
};
